"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollcticAllowDonationState = void 0;
var CollcticAllowDonationState;
(function (CollcticAllowDonationState) {
    CollcticAllowDonationState["DonationAllow"] = "donation-allow";
    CollcticAllowDonationState["DonationNotAllow"] = "donation-not-allow";
})(CollcticAllowDonationState = exports.CollcticAllowDonationState || (exports.CollcticAllowDonationState = {}));
//# sourceMappingURL=collctiv-allow-state.js.map